import type { AgentThreadShareVo } from "@/api";
import { api } from "@/api";
import useSWR from "swr";

const fetchSharedThread = async (
  threadId: string
): Promise<AgentThreadShareVo> => {
  const response = await api.threads.getSharedThread(threadId);
  return response.data;
};

export function useSharedThread(threadId: string) {
  const shouldFetch = !!threadId;

  const { data, isLoading, error } = useSWR<AgentThreadShareVo>(
    shouldFetch ? ["shared-thread", threadId] : null,
    ([, id]) => fetchSharedThread(id as string),
    {
      revalidateOnMount: shouldFetch,
    }
  );

  return {
    thread: data,
    isLoading,
    error,
  };
}
